/* Goal Station: play Vimeo / YouTube links in an on-page pop-up instead of opening a new tab (Coach Guide and any other video link). */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function embed(href){
    var yt = href.match(/(?:youtube\.com\/watch\?(?:.*&)?v=|youtu\.be\/)([\w-]{11})/);
    if(yt) return 'https://www.youtube-nocookie.com/embed/' + yt[1] + '?autoplay=1&rel=0';
    var vm = href.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/([a-f0-9]+))?/);
    if(vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1' + (vm[2] ? '&h=' + vm[2] : '');
    return '';
  }
  function open(src, opener){
    var m = document.createElement('div');
    m.className = 'watch'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', 'Video');
    m.innerHTML = '<div class="watch__box"><button class="watch__close" type="button" aria-label="Close"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 3l10 10M13 3 3 13"/></svg></button><iframe src="' + src + '" title="Video" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe></div>';
    document.body.appendChild(m);
    var prev = document.body.style.overflow; document.body.style.overflow = 'hidden';
    var onKey = function(e){ if(e.key === 'Escape') close(); };
    var close = function(){
      document.removeEventListener('keydown', onKey);
      m.classList.remove('is-open');
      setTimeout(function(){ if(m.parentNode) m.parentNode.removeChild(m); }, reduce ? 0 : 220);
      document.body.style.overflow = prev;
      if(opener && opener.focus) opener.focus();
    };
    document.addEventListener('keydown', onKey);
    m.addEventListener('click', function(e){ if(e.target === m) close(); });
    m.querySelector('.watch__close').addEventListener('click', close);
    requestAnimationFrame(function(){ m.classList.add('is-open'); m.querySelector('.watch__close').focus(); });
  }
  document.addEventListener('click', function(e){
    if(e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || !e.target.closest) return;
    var a = e.target.closest('a[href*="vimeo.com/"],a[href*="youtube.com/watch"],a[href*="youtu.be/"]');
    if(!a || a.hasAttribute('data-watch')) return;
    var href = a.getAttribute('href') || '', src = embed(href);
    e.preventDefault();
    if(src){ open(src, a); return; }
    /* named Vimeo URL without a numeric id: ask Vimeo for the id */
    fetch('https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(href)).then(function(r){ return r.json(); }).then(function(j){
      var s = j && j.video_id ? embed('https://vimeo.com/' + j.video_id) : '';
      if(s) open(s, a); else window.open(href, '_blank', 'noopener');
    }).catch(function(){ window.open(href, '_blank', 'noopener'); });
  });
})();
